export default __webpack_public_path__ + "static/media/loading_long.51f2a804.gif";